import { useIntl, type UserAmlQuestionnaireAccountCreationReasons } from '@capsicum/common';
import { amlQuestionnaireReducerAtom } from '@capsicum/features/regulations/shared';
import { useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';

type CreationReasonItem = {
	checked: boolean;
	text: string;
	value: UserAmlQuestionnaireAccountCreationReasons;
};

export const useAmlAccountCreationReasons = () => {
	const { $t } = useIntl();
	const [choice, setChoice] = useState<Array<UserAmlQuestionnaireAccountCreationReasons>>([]);
	const dispatch = useSetAtom(amlQuestionnaireReducerAtom);

	useEffect(() => {
		dispatch({ data: { accountCreationReasons: choice }, type: 'UPDATE_FORM_DATA' });
		dispatch({ isValid: choice.length > 0, stepId: 'AccountCreationReasons', type: 'UPDATE_STEP_VALIDITY' });
	}, [choice]);

	const choiceHandler = (checked: boolean, option: UserAmlQuestionnaireAccountCreationReasons) => {
		if (checked) setChoice([...choice, option]);
		else setChoice(choice.filter(item => item !== option));
	};

	const options: Array<CreationReasonItem> = [
		{
			checked: false,
			text: $t('amlQuestionnaire.firstStep.option1'),
			value: 'fan'
		},
		{
			checked: false,
			text: $t('amlQuestionnaire.firstStep.option2'),
			value: 'trader'
		}
	];

	return { choiceHandler, options };
};
